
import Tools from "@/ts/Tools";
import BigNumber from "bignumber.js";
import { ColorEnum } from "./SuperEnum";

/**
 * 数字补位
 */
Number.prototype.ComplementNumber = function (n: number, char: string = "0") {
    return (Array(n).join(char) + this).slice(-n);
}

/**
 * 保留小数不进位
 */
Number.prototype.KeepDecimal = function (n: number = 2) {
    let v = new BigNumber(this.toString());
    let ls_v = v.toString();
    let find_dian = false;
    let ret_v = "";
    let run_count = 0;
    for (let i = 0; i < ls_v.length; i++) {
        const m = ls_v[i];
        if (find_dian) {
            run_count++;
            if (run_count > n)
                break;
        }
        ret_v += m;
        if (m == ".")
            find_dian = true;
    }
    return ret_v;
}

/**
 * 格式化时间戳
 */
Number.prototype.ToDateTime = function (format: 
    "[yyyy,MM,dd]" | 
    "[HH,mm]" | 
    "[HH,mm,ss]" | 
    "yyyy-MM-dd HH:mm:ss" | 
    "yyyy/MM/dd HH:mm:ss" | 
    "yyyyMMddHHmmss" | 
    "yyyy-MM-dd" | 
    "yyyy/MM/dd" | 
    "yyyyMMdd" |
     "HH:mm:ss" | 
     "HHmmss" | 
     "HH:mm" = "yyyy-MM-dd HH:mm:ss") {
    return Tools.ConvertTimestamp(this as number, format);
}


Object.defineProperty(Array.prototype, 'JsonToVO', {
    value: function <T>() {
        return <T>JSON.parse(this as any);
    },
    enumerable: false, // 设置该属性不可枚举
    writable: true, // 设置该属性的值可以被修改
    configurable: true // 设置该属性的特性可以被修改或删除
});


Object.defineProperty(Array.prototype, 'ToJson', {
    value: function() {
        return JSON.stringify(this);
    },
    enumerable: false, // 设置该属性不可枚举
    writable: true, // 设置该属性的值可以被修改
    configurable: true // 设置该属性的特性可以被修改或删除
});

/**
 * 添加一堆
 */
Object.defineProperty(Array.prototype, 'PushAll', {
    value: function <T>(arr: Array<any>) {
        // 这里将当前数组实例赋值给 _this_arr 并指定泛型类型 T
        let _this_arr: Array<T> = this as Array<T>;
        arr.forEach(v => {
            _this_arr.push(v);
        });
    },
    enumerable: false, // 不可枚举，避免 for...in 遍历到该方法
    writable: true,    // 允许修改该方法
    configurable: true // 允许删除或修改该属性的特性
});



/**
 * 正序
 */
Object.defineProperty(Array.prototype, 'OrderBy', {
    value: function <T>(select_pro: (x: T) => number): void {
        let arr: Array<T> = this as Array<T>;
        arr.sort((a, b) => {
            return select_pro(a) - select_pro(b);
        });
    },
    enumerable: false,
    writable: true,
    configurable: true
});

/**
 * 倒序
 */
Object.defineProperty(Array.prototype, 'OrderByDesc', {
    value: function <T>(select_pro: (x: T) => number): void {
        let arr: Array<T> = this as Array<T>;
        arr.sort((a, b) => {
            return select_pro(b) - select_pro(a);
        });
    },
    enumerable: false,
    writable: true,
    configurable: true
});

/**
 * 根据索引获取数组内容
 */
Object.defineProperty(Array.prototype, 'GetValueOfIndex', {
    value: function <T>(index: number): {
        flag: boolean,
        data: T | null
    } {
        let arr: Array<any> = this;
        if (arr.length >= index + 1) {
            return {
                flag: true,
                data: <T>arr[index]
            };
        }
        return {
            flag: false,
            data: null
        };
    },
    enumerable: false,
    writable: true,
    configurable: true
});

/**
 * 查询Linq
 */
Object.defineProperty(Array.prototype, 'Where', {
    value: function <T>(where_fun: (x: T) => boolean): T[] {
        let t_list: T[] = [];
        for (let i = 0; i < this.length; i++) {
            const v = this[i];
            if (where_fun(v)) {
                t_list.push(v);
            }
        }
        return t_list;
    },
    enumerable: false,
    writable: true,
    configurable: true
});

/**
 * 求和
 */
Object.defineProperty(Array.prototype, 'Sum', {
    value: function <T>(callfun: (x: T) => number): number {
        let arr = this as Array<T>;
        let all_count = 0;
        arr.forEach(v => {
            all_count += callfun(v);
        });
        return all_count;
    },
    enumerable: false,
    writable: true,
    configurable: true
});

/**
 * 检测是否存在
 */
Object.defineProperty(Array.prototype, 'IsFind', {
    value: function <T>(where_fun: (x: T) => boolean): boolean {
        let arr = this as Array<T>;
        return arr.Where(where_fun).length > 0;
    },
    enumerable: false,
    writable: true,
    configurable: true
});

Object.defineProperty(Array.prototype, 'Select', {
    value: function <T, TOut extends any>(select_fun: (x: T) => TOut): TOut[] {
        let t_list: TOut[] = [];
        for (let i = 0; i < this.length; i++) {
            const v = this[i];
            t_list.push(select_fun(v));
        }
        return t_list;
    },
    enumerable: false,
    writable: true,
    configurable: true
});

/**
 * 异步分离函数
 */
Object.defineProperty(Array.prototype, 'SelectAsync', {
    value: async function <T, TOut extends any>(select_fun: (x: T) => Promise<TOut>): Promise<TOut[]> {
        let t_list: TOut[] = [];
        for (let i = 0; i < this.length; i++) {
            const v = this[i];
            t_list.push(await select_fun(v));
        }
        return t_list;
    },
    enumerable: false,
    writable: true,
    configurable: true
});

/**
 * 两个数组合并的集合
 * @param array 
 */
Object.defineProperty(Array.prototype, 'Union', {
    value: function <T>(array: T[]): T[] {
        let tempArr = (<Array<T>>this).concat(array);
        return tempArr.Distinct();
    },
    enumerable: false,
    writable: true,
    configurable: true
});

/**
 * 去除重复项
 */
Object.defineProperty(Array.prototype, 'Distinct', {
    value: function <T>(): T[] {
        let tempArr: any[] = [];
        let arr = <Array<T>>this;
        arr.filter(v => tempArr.includes(v) ? false : tempArr.push(v));
        return tempArr;
    },
    enumerable: false,
    writable: true,
    configurable: true
});

Object.defineProperty(Array.prototype, 'DistinctOfPro', {
    value: function <T>(...keys: [keyof T]): T[] {
        let arr = this as Array<T>;
        let temp_arr: T[] = [];

        arr.forEach(v => {
            // 检测是否存在
            if (temp_arr.Where((x) => {
                let is_distinct: boolean = true;
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    if (x[key] != v[key]) {
                        is_distinct = false;
                        break;
                    }
                }
                return is_distinct;
            }).length === 0) {
                temp_arr.push(v);
            }
        });
        return temp_arr;
    },
    enumerable: false,
    writable: true,
    configurable: true
});



/**
 * 清空数据
 */
Object.defineProperty(Array.prototype, 'Clear', {
    value: function <T>() {
        let arr = this as Array<T>;
        arr.splice(0, arr.length);
    },
    enumerable: false,
    writable: true,
    configurable: true
});

/**
 * 移除数据
 */
Object.defineProperty(Array.prototype, 'ToRemove', {
    value: function <T>(...input_arr: T[] | [keyof T, any][]): void {
        let arr = this as Array<T>;
        for (let i = arr.length - 1; i >= 0; i--) {
            const v = arr[i];
            let is_find: boolean = false;
            for (let k = 0; k < input_arr.length; k++) {
                let k_v = input_arr[k];
                if (k_v instanceof Array) {
                    let key: keyof T = k_v[0];
                    let value: any = k_v[1];
                    if (value == v[key]) {
                        is_find = true;
                    } else {
                        is_find = false;
                        break;
                    }
                } else {
                    if (k_v == v) {
                        is_find = true;
                    } else {
                        is_find = false;
                        break;
                    }
                }
            }
            if (is_find) {
                // 删除元素
                arr.splice(i, 1);
            }
        }
    },
    enumerable: false,
    writable: true,
    configurable: true
});

Object.defineProperty(Array.prototype, 'ToRemoveIndexOf', {
    value: function <T>(...keys: string[]) {
        let arr = this as Array<string>;
        for (let i = this.length - 1; i >= 0; i--) {
            let can_remove = false;
            for (let k = 0; k < keys.length; k++) {
                const key = keys[k];
                if (arr[i].indexOf(key) !== -1) {
                    can_remove = true;
                    break;
                }
            }
            if (can_remove) {
                arr.splice(i, 1);
            }
        }
    },
    enumerable: false,
    writable: true,
    configurable: true
});


Object.defineProperty(Array.prototype, 'ToRemoveNotIndexOf', {
    value: function <T>(...keys: string[]) {
        let arr = this as Array<string>;
        for (let i = arr.length - 1; i >= 0; i--) {
            let can_remove = false;
            for (let k = 0; k < keys.length; k++) {
                const key = keys[k];
                if (arr[i].indexOf(key) === -1) {
                    can_remove = true;
                    break;
                }
            }
            if (can_remove) {
                arr.splice(i, 1);
            }
        }
    },
    enumerable: false,
    writable: true,
    configurable: true
});


String.prototype.AlertError = function () {
    Tools.AlertError(this as string);
}

String.prototype.AlertSuccess = function () {
    Tools.AlertSuccess(this as string);
}

/**
 * 日志
 */
String.prototype.Log = function (tag: string, color: ColorEnum, fontSize: number) {
    Tools.ShowLog(tag, this, color, fontSize);
}


/**
 * 转换成JSON对象
 */
String.prototype.ToJsonVO = function (): {
    flag: boolean,
    data: any
} {
    return Tools.ToJsonVO(this as string);
}

String.prototype.IsNotNull = function () {
    return Tools.IsNotNull(this as string);
};

String.prototype.IsNull = function () {
    return Tools.IsNull(this as string);
}

String.prototype.IsJson = function (): boolean {
    return Tools.IsJson(this as string);
}